var map = {
	"./1.5_banner.png": "D1rG",
	"./1.5_jianji.png": "iR0c",
	"./1.5_lc.png": "83M/",
	"./1.5_pcr.png": "TzzN",
	"./1.5_snp.png": "Ur2z",
	"./1.5_yuan.png": "Muae",
	"./MIX2500_1.png": "m5BE",
	"./MIX2500_10.png": "Qw2f",
	"./MIX2500_11.png": "irUt",
	"./MIX2500_2.png": "zM0W",
	"./MIX2500_3.png": "jlHz",
	"./MIX2500_4.png": "xWTe",
	"./MIX2500_5.png": "8F8s",
	"./MIX2500_6.png": "+ZuL",
	"./MIX2500_7.png": "bfX4",
	"./MIX2500_8.png": "p3Zl",
	"./MIX2500_9.png": "IvRj",
	"./RNA1.png": "knBd",
	"./RNA_1.png": "CATk",
	"./RNA_2.png": "ukU3",
	"./RNA_3.png": "Cq/I",
	"./T15KL_1.png": "E4WG",
	"./T15KL_2.png": "bdTU",
	"./T15KL_3.png": "Se8g",
	"./Virus/Adeno/banner.png": "fKNR",
	"./Virus/Adeno/ys.png": "q65G",
	"./Virus/Adeno/ys_bg.png": "OVak",
	"./Virus/Adenovirus/lc.png": "1cAp",
	"./Virus/Adenovirus/ys.png": "V101",
	"./Virus/Adenovirus/ys_bg.png": "ymKE",
	"./Virus/Lentivirus/banner.png": "QMRq",
	"./Virus/Lentivirus/lc.png": "nDpZ",
	"./Virus/Lentivirus/ys.png": "G5J8",
	"./Virus/Lentivirus/ys_bg.png": "ARBh",
	"./Virus/Virus/banner.png": "QHG6",
	"./Virus/Virus/fuys_bj.png": "WUsl",
	"./Virus/Virus/fwys_pt.png": "Lbhi",
	"./akta_1.png": "JjpF",
	"./am096_1.png": "Wnkd",
	"./amplicon_1.png": "Sroz",
	"./amplicon_2.png": "nNFb",
	"./amplicon_3.png": "BPVm",
	"./bacterial_1.png": "LiYN",
	"./bacterial_2.png": "ONf5",
	"./bacterial_icon_1.png": "XBwi",
	"./bacterial_icon_2.png": "it0L",
	"./bacterial_icon_3.png": "iV6U",
	"./bacterial_icon_4.png": "01NO",
	"./banner_1.png": "iRaI",
	"./banner_10.png": "YX2f",
	"./banner_11.png": "GMeU",
	"./banner_12.png": "ZG3O",
	"./banner_13.png": "i8Nl",
	"./banner_14.png": "2H3d",
	"./banner_15.png": "f93W",
	"./banner_16.png": "II0I",
	"./banner_17.png": "UO9I",
	"./banner_18.png": "/P2F",
	"./banner_19.png": "tgce",
	"./banner_2.png": "ABKN",
	"./banner_3.png": "hfd9",
	"./banner_4.png": "A0eh",
	"./banner_5.png": "Kpi7",
	"./banner_7.png": "H7MU",
	"./banner_9.png": "uqOq",
	"./barcode_1.png": "KJef",
	"./barcode_2.png": "ISF8",
	"./barcode_3.png": "GF8X",
	"./barcode_4.png": "5y6j",
	"./case.png": "O7x/",
	"./cell_1.png": "EBtd",
	"./cell_2.png": "0BSh",
	"./cell_3.png": "tk0G",
	"./cell_4.png": "JCqB",
	"./cell_arrow.png": "k7/C",
	"./circ_1.png": "hDSW",
	"./circ_icon_1.png": "V+/S",
	"./circ_icon_2.png": "LgHR",
	"./circ_icon_3.png": "I8kq",
	"./compose12_1.png": "CmbB",
	"./compose192_1.png": "TCgq",
	"./compose768_1.png": "10jb",
	"./compose768_11.png": "XNcV",
	"./compose_1.png": "c/NG",
	"./compose_2.png": "wKwf",
	"./compose_3.png": "J/8V",
	"./compose_3_1.png": "Y28D",
	"./compose_3_2.png": "UoTq",
	"./compose_map.png": "pxKD",
	"./copy.png": "zOHj",
	"./denovo_icon_1.png": "dqLk",
	"./denovo_icon_2.png": "u8ty",
	"./denovo_icon_3.png": "xtxn",
	"./details_1.png": "21IC",
	"./develop_1.png": "V0gI",
	"./device_1.png": "BaKg",
	"./device_2.png": "saFn",
	"./device_3.png": "Jbo6",
	"./device_4.png": "p7Ln",
	"./device_5.png": "8qje",
	"./device_6.png": "EUe1",
	"./device_mini_1.png": "8TYV",
	"./device_mini_10.png": "hkn2",
	"./device_mini_2.png": "7CJK",
	"./device_mini_3.png": "tLsj",
	"./device_mini_4.png": "uWVw",
	"./device_mini_5.png": "yT+o",
	"./device_mini_6.png": "xFK/",
	"./device_mini_7.png": "A6dD",
	"./device_mini_8.png": "znDR",
	"./device_mini_9.png": "BJ1/",
	"./dna_1.png": "e6Z8",
	"./dna_2.png": "UYQD",
	"./dna_3.png": "+mi1",
	"./dna_icon_1.png": "vgw7",
	"./dna_icon_2.png": "CIuu",
	"./dna_icon_3.png": "VFwQ",
	"./dna_icon_4.png": "UVRe",
	"./dna_icon_5.png": "mol4",
	"./dna_icon_6.png": "RyTx",
	"./dna_icon_7.png": "zOp/",
	"./enLinkIcon.png": "ovMv",
	"./eukaryotic_1.png": "0lmg",
	"./eukaryotic_icon_1.png": "D5bx",
	"./eukaryotic_icon_2.png": "HZ7i",
	"./extraction_1.png": "DMip",
	"./extraction_2.png": "v4Ww",
	"./full_1.png": "k+0A",
	"./full_2.png": "DPzf",
	"./full_icon_1.png": "xohP",
	"./full_icon_2.png": "ID+1",
	"./full_icon_3.png": "n7oK",
	"./full_icon_4.png": "HV68",
	"./fungal_1.png": "RFyK",
	"./fungal_2.png": "4YR2",
	"./gen_1.png": "t21q",
	"./gen_1_old.png": "/Fhj",
	"./gen_2.png": "RhlK",
	"./gen_3.png": "j5Pq",
	"./gen_icon_1.png": "COAF",
	"./gen_icon_2.png": "ucUW",
	"./gen_icon_3.png": "FHha",
	"./gen_icon_4.png": "OoXG",
	"./gen_icon_5.png": "BFCb",
	"./gen_icon_6.png": "UY38",
	"./gen_icon_7.png": "tmBi",
	"./gen_icon_8.png": "zjNB",
	"./global_1.png": "NyPd",
	"./hot.png": "Ix9H",
	"./human_1.png": "zewc",
	"./human_icon_1.png": "TxzC",
	"./human_icon_2.png": "dO6T",
	"./human_icon_3.png": "30RK",
	"./human_icon_4.png": "E35d",
	"./human_icon_5.png": "GNX7",
	"./human_icon_9.png": "hd1j",
	"./icon_RNA.png": "K/6t",
	"./icon_chart.png": "QMrb",
	"./icon_chart2.png": "eLgr",
	"./icon_chart_white.png": "zQ2m",
	"./icon_check3.png": "xP1T",
	"./icon_check3_disable.png": "y+yI",
	"./icon_copy.png": "758b",
	"./icon_copy2.png": "Qa4v",
	"./icon_down.png": "a4CZ",
	"./icon_down2.png": "yBjr",
	"./icon_down3.png": "hOkp",
	"./icon_download.png": "wqNP",
	"./icon_email.png": "LNbV",
	"./icon_miRNA.png": "ABeg",
	"./icon_more.png": "mYqV",
	"./icon_phone_primary.png": "lmSt",
	"./icon_search.png": "3rhe",
	"./icon_service_primary.png": "UB9F",
	"./icon_siRNA.png": "pyjb",
	"./icon_success.png": "JsnA",
	"./icon_tel.png": "Psa6",
	"./icon_user.png": "j8KV",
	"./icon_warn.png": "sboA",
	"./identification_1.png": "d6th",
	"./identification_2.png": "4dM9",
	"./identification_3.png": "im38",
	"./img_top.png": "NXDi",
	"./inc_1.png": "TzXi",
	"./inc_icon_1.png": "k4W6",
	"./inc_icon_2.png": "mkYi",
	"./inc_icon_3.png": "KoM5",
	"./its_1.png": "Tk9L",
	"./list.png": "TV/B",
	"./login_bg.png": "aF6v",
	"./logo.png": "iQH9",
	"./macrogenome_1.png": "rPpZ",
	"./macrogenome_icon_1.png": "mU/w",
	"./macrogenome_icon_2.png": "95oN",
	"./macrogenome_icon_3.png": "iBEB",
	"./macrogenome_icon_4.png": "LrpJ",
	"./macrogenome_icon_5.png": "WQ5b",
	"./macrogenome_icon_6.png": "kw93",
	"./mc15k_1.png": "2cQ/",
	"./metal_1.png": "q+Vc",
	"./metal_2.png": "HVsR",
	"./metal_3.png": "X2KV",
	"./metal_4.png": "lICC",
	"./metal_5.png": "dEIO",
	"./metal_6.png": "O2y/",
	"./metal_7.png": "4pe3",
	"./metal_8.png": "5Us/",
	"./metal_9.png": "Hy50",
	"./mini7ks_1.png": "XtKU",
	"./mini_1.png": "kukf",
	"./mitochondrial_1.png": "6mBp",
	"./mobile/arrow.png": "kMgV",
	"./mobile/arrow_down.png": "j+dE",
	"./mobile/bg_primary.png": "s/R1",
	"./mobile/bg_red.png": "d2zu",
	"./mobile/empty.png": "wCtS",
	"./mobile/icon_back.png": "Bwel",
	"./mobile/icon_car.png": "QdAR",
	"./mobile/icon_code.png": "/6DE",
	"./mobile/icon_compose.png": "gXRl",
	"./mobile/icon_gene.png": "shmb",
	"./mobile/icon_ing.png": "4joE",
	"./mobile/icon_integral.png": "hIqd",
	"./mobile/icon_lock.png": "aMAz",
	"./mobile/icon_molecular.png": "UBXn",
	"./mobile/icon_ok.png": "5Yah",
	"./mobile/icon_other.png": "MhNP",
	"./mobile/icon_phone.png": "osyB",
	"./mobile/icon_phone2.png": "85Oc",
	"./mobile/icon_search.png": "Qo0D",
	"./mobile/icon_status_1.png": "aJWP",
	"./mobile/icon_stauts_2.png": "9Dp6",
	"./mobile/icon_success.png": "79eE",
	"./mobile/icon_sunger.png": "5wrG",
	"./mobile/icon_time.png": "Shc/",
	"./mobile/icon_user.png": "0VzF",
	"./mobile/icon_user2.png": "g32T",
	"./mobile/icon_wait.png": "riWg",
	"./mobile/logo.png": "KoaG",
	"./mobile/logo_2.png": "xjxK",
	"./mobile/status_bg_ing.png": "3gSY",
	"./mobile/status_part.png": "yrsM",
	"./mobile/sunger_banner.png": "YEum",
	"./mobile/top_bg.png": "91Xn",
	"./mp2500_1.png": "v1Vv",
	"./new.png": "X10k",
	"./news_1.png": "jMto",
	"./order_bg.png": "KOb7",
	"./pcr_4.png": "phbX",
	"./primer_service_1.png": "CmjO",
	"./product_1.png": "UNxw",
	"./product_2.png": "CYWt",
	"./product_3.png": "e6SX",
	"./profile_1.png": "6luH",
	"./prokaryotic_1.png": "UvVV",
	"./prokaryotic_icon_1.png": "bZbO",
	"./prokaryotic_icon_2.png": "5VVi",
	"./prokaryotic_icon_3.png": "jLGE",
	"./prokaryotic_icon_4.png": "uWAX",
	"./prokaryotic_icon_5.png": "dtPg",
	"./prokaryotic_icon_6.png": "bFGW",
	"./prokaryotic_icon_7.png": "2OM1",
	"./qpcr_1.png": "BWhj",
	"./qpcr_2.png": "B+gL",
	"./qpcr_3.png": "A+Ku",
	"./qpcr_4.png": "fz2t",
	"./qpcr_5.png": "+2xm",
	"./qpcr_6.png": "AyIx",
	"./qpcr_7.png": "0lft",
	"./qpcr_8.png": "yAdQ",
	"./qrcode.png": "/4D4",
	"./quit.png": "4dWG",
	"./r01_1.png": "OZ2T",
	"./rdna_1.png": "l6nN",
	"./rdna_2.png": "G/FD",
	"./rdna_4.png": "j/u0",
	"./resequencing_1.png": "bfjJ",
	"./resequencing_2.png": "8x5q",
	"./resequencing_icon_1.png": "8jMk",
	"./resequencing_icon_2.png": "KQ3g",
	"./resequencing_icon_3.png": "2p3g",
	"./resequencing_icon_4.png": "pE0G",
	"./resequencing_icon_5.png": "FKYj",
	"./resequencing_icon_6.png": "1aOC",
	"./rt20_1.png": "XibP",
	"./sanger_1.png": "pBSu",
	"./sanger_2.png": "m1rs",
	"./sanger_2_old.png": "nlbP",
	"./sanger_icon1.png": "f6Uy",
	"./sanger_icon1_active.png": "qjIb",
	"./sanger_icon2.png": "Gxdb",
	"./sanger_icon2_active.png": "mwBe",
	"./sanger_icon3.png": "TCCI",
	"./sanger_icon3_active.png": "HnZN",
	"./sanger_service_1.png": "MDHf",
	"./sanger_service_1_old.png": "EjVT",
	"./sanger_service_2.png": "ASJr",
	"./sanger_service_2_old.png": "0al7",
	"./sanger_service_3.png": "/BtA",
	"./sanger_service_3_old.png": "4+O4",
	"./sanger_service_4.png": "5526",
	"./sanger_service_4_old.png": "OLCy",
	"./save_icon_1.png": "LJke",
	"./save_icon_2.png": "hvK7",
	"./save_icon_3.png": "c4ah",
	"./save_icon_4.png": "12kt",
	"./save_icon_5.png": "HWn1",
	"./service_icon_1.png": "KZuH",
	"./service_icon_2.png": "YvKy",
	"./small_1.png": "ewMN",
	"./small_icon_1.png": "sqWX",
	"./small_icon_2.png": "XM6D",
	"./small_icon_3.png": "UnB4",
	"./snp_1.png": "YyBL",
	"./snp_2.png": "byFk",
	"./snp_3.png": "Zr93",
	"./snp_4.png": "B3Cj",
	"./snp_5.png": "naF0",
	"./snp_6.png": "FegY",
	"./snp_7.png": "1jnz",
	"./snp_service_1.png": "q8su",
	"./snp_service_2.png": "bEPG",
	"./snp_service_3.png": "5RJr",
	"./snp_service_4.png": "9j/5",
	"./snp_service_5.png": "4fBK",
	"./specific_1.png": "elGe",
	"./specific_4.png": "iCf4",
	"./specific_5.png": "V1Mm",
	"./specific_6.png": "mMGu",
	"./specific_7.png": "lPPz",
	"./ssr_2.png": "MVQA",
	"./ssr_3.png": "2wFP",
	"./ssr_4.png": "Oo99",
	"./ssr_5.png": "ARhQ",
	"./ssr_6.png": "XInv",
	"./ssr_7.png": "gGwy",
	"./ssr_8.png": "j8o/",
	"./ssr_9.png": "Q/r6",
	"./ssr_service_1.png": "e4Q1",
	"./ssr_service_2.png": "Scau",
	"./ssr_service_3.png": "qphm",
	"./target_1.png": "9E1Z",
	"./target_icon_1.png": "G0Np",
	"./target_icon_2.png": "dqZ5",
	"./target_icon_3.png": "jOca",
	"./target_icon_4.png": "0kHF",
	"./target_icon_5.png": "ix9s",
	"./tm30_1.png": "WGbe",
	"./vector_1.png": "XGdt",
	"./vector_2.png": "5ljN",
	"./wh5_1.png": "lbM+",
	"./whole_1.png": "+3cI",
	"./whole_3.png": "8UEr",
	"./whole_icon_1.png": "nXgd",
	"./whole_icon_2.png": "4cQs",
	"./whole_icon_3.png": "pHx/",
	"./whole_icon_5.png": "DdBZ",
	"./whole_icon_6.png": "ODAH",
	"./zl_bg.png": "u/2f",
	"./zl_keji.png": "kezA",
	"./zl_yy1.png": "8sIN",
	"./zl_yy2.png": "pLC9",
	"./zl_yy3.png": "SXI0",
	"./zx.png": "d4MG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tsha";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.png$
// module id = tsha
// module chunks = 1